import React from 'react'
import Profile from '../../assets/images/deepak-k.png';
import { BiWorld } from "react-icons/bi";
import { BiUserCheck } from "react-icons/bi";

function Candidprofile() {
  return (
    <div>
    <div class="talent_profile">
                        <div class="talent_profile_img">
                            <img src={Profile} alt="Logo"/>                                
                        </div>
                        <div class="talent_profile_content">
                            <h5>Vitor Cezar D.</h5>
                            <p><BiWorld className='me-1'/>6 Overlapping hours
                                Campbell (GMT-7)</p>
                            <span className="profile_active">Available</span>
                        </div>                                    
                    </div>
                    <div className="job_add_must_skill text-end">                                    
                        <span className="d-block"><BiUserCheck className='me-1'/>Suggested match</span>
                    </div> 
    </div>
  )
}

export default Candidprofile